import { useTranslations } from 'next-intl';

import { BaseFieldProps } from '@/fo/ui/kit/field/base';
import { UiKitInputBase } from '@/fo/ui/kit/input/base';

import { UserInfo } from '../../types';

import { styles } from './AboutUserSection.styles';

export interface AboutUserSectionProps {
  getFieldProps: (name: string) => BaseFieldProps;
  userInfo?: UserInfo;
}

export function AboutUserSection({
  getFieldProps,
  userInfo
}: AboutUserSectionProps) {
  const slots = styles();

  const t = useTranslations('review.form.aboutUser');

  return (
    <div className={slots.base()}>
      <UiKitInputBase
        label={t('name.label')}
        className={slots.name()}
        placeholder={t('name.placeholder')}
        value={userInfo?.name}
        {...getFieldProps('name')}
        required
      />
    </div>
  );
}
